import whatsNewMock from './mock';

// eslint-disable-next-line import/prefer-default-export
export const getWhatsNewData = () => whatsNewMock;
